import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { EditIcon } from "../../../ui/icons/edit"
import { useEffect } from "react"
import { GetAllFaseAvvio } from "./slice"
import { formatterDate, getNotificationLabelByValue, } from "../../../utils"
import { addDays } from "date-fns"

export function MonitoringFaseAvvioList() {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const faseAvvio = useAppSelector(state => state.faseAvvio)

    return (
        <div className="mt-6">
            <table id="users-table" className="w-[100%]">
                <thead className="h-[52px] uppercase">
                    <tr>
                        <th style={{ borderTopLeftRadius: '8px' }}>Regione</th>
                        <th>SOT</th>
                        <th>Cod. Op</th>
                        <th>Ciente</th>
                        <th>Data Ingresso</th>
                        <th>Data Fine</th>
                        <th>Scadenza</th>
                        <th>Notifica</th>
                        <th>Visita</th>
                        <th>Data M024</th>
                        <th style={{ borderTopRightRadius: '8px' }}>Certificato M005/M029</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        faseAvvio.GetAllFaseAvvioResponse?.map((fs, index) => (
                            <tr
                                key={index}
                                style={{
                                    color: '#4D797F',
                                    background: index % 2 === 0 ? '#F2F7F7' : '#FFFFFF'
                                }}
                            >
                                <td>{fs.customerRegion}</td>
                                <td>{fs.customerHeadQuarters}</td>
                                <td>{fs.customerClientCode}</td>
                                <td>{fs.customerCompanyName}</td>
                                <td>{formatterDate(fs.startingDate)}</td>
                                <td>{formatterDate(fs.endingDate)}</td>
                                <td></td>
                                <td>{formatterDate(addDays(new Date(fs.startingDate), 90))}</td>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                            </tr>
                        ))}

                </tbody>
            </table>
        </div>
    )
}